import { StripeCardDetails } from '../../StripeCustomer';
import Blob from './Blob';

export default interface Document {
	documentType: string;
	description?: string;
	blob?: Blob;
	stripeCardDetails?: StripeCardDetails;
}

export const createDocument = (documentType = '', description: string = null): Document => {
	return {
		documentType,
		description,
		blob: null,
		stripeCardDetails: null
	};
};
